﻿import { mutations } from "@/graphql";
import { useContext, useState } from "react";
import { useMutation } from "@apollo/client/react";
import { useSnackbar } from "notistack";
import { useTextDomainContext } from "../../app/providers";

export const useAddCompanyToTenant = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const { enqueueSnackbar } = useSnackbar();
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addCompanyToTenant, { loading, data }] = useMutation<any>(
    mutations.addCompanyToTenant,
    {
      onCompleted: (response) => {
        if (response?.addCompanyToTenant?.success) {
          enqueueSnackbar(gettext("The company has been linked."), {
            variant: "success",
          });
          setResetForm(true);
        } else {
          enqueueSnackbar(gettext("The company already linked."), {
            variant: "error",
          });
        }
        setSuccess(response?.addCompanyToTenant?.success);
        // setTimeout(() => {
        //   setSuccess(false);
        //   setResetForm(false);
        // }, 5000);
        onCompleted();
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
        enqueueSnackbar(message, {
          variant: "error",
        });
      },
      refetchQueries: ["TenantsCompaniesList", "TenantsList"],
    },
  );

  return {
    addCompanyToTenant,
    loading,
    success,
    data,
    resetForm,
  };
};
